import React from 'react'

/* Form & Form Validation */
import * as Yup from 'yup'

import { Form, Input } from 'formik-antd'
import { Divider } from 'antd'

import ModalForm from '../../../../../core/components/form/modalForm'
import { isNotValid, translateSymfonyErrorToFormik } from '../../../../../core/utils/form'

const ValidationSchema = Yup.object().shape({
  person: Yup.string().required('Cannot be blank.'),
  notes: Yup.string().required('Cannot be blank.')
})

const Formulario = (props) => {
  const { onCancel, createQAComment, qaId } = props

  function handleSubmit (values, bag) {
    const form = {
      ...values,
      qaId
    }

    createQAComment(form, {
      onSuccess: (data) => {
        bag.setSubmitting(false)
        onCancel()
      },
      onError: (error, variables, context) => {
        bag.setSubmitting(false)
        if (error.response.status === 400) {
          const data = error.response?.data
          if (isNotValid(data)) {
            bag.setErrors(translateSymfonyErrorToFormik(data?.errors?.children))
          }
        }
      }
    })
  }

  const initialValues = { person: '', notes: '' }

  return (
    <ModalForm
      onCancel={onCancel}
      title='LQA'
      initialValues={initialValues}
      validationSchema={ValidationSchema}
      onSubmit={handleSubmit}
      visible
      width={700}
      render={() => (
        <>
          <Form.Item label='Person' name='person' hasFeedback showValidateSuccess required>
            <Input name='person' placeholder='Person' />
          </Form.Item>
          <Form.Item label='Notes' name='notes' hasFeedback showValidateSuccess required>
            <Input.TextArea name='notes' placeholder='Notes' />
          </Form.Item>

          <Divider plain />
        </>
      )}
    />
  )
}

export default Formulario
